import { render, staticRenderFns } from "./NewViewer.vue?vue&type=template&id=637a8234&"
import script from "./NewViewer.vue?vue&type=script&lang=js&"
export * from "./NewViewer.vue?vue&type=script&lang=js&"
import style0 from "./NewViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports